import { Suspense } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { Loader } from '@/shared/ui/loader'
import { DeferredTab } from '@pages/donor-detail/ui/DeferredTab'

function DeferredRoute() {
  const { visitId } = Route.useParams()
  return (
    <Suspense fallback={<Loader />}>
      <DeferredTab visitId={visitId} canOverrideDeferral />
    </Suspense>
  )
}

export const Route = createFileRoute('/_protected/donors/$visitId/deferred')({
  component: DeferredRoute,
})
